import StepperContentContainer from "../StepperContentContainer"
import { useContext } from "react"
import { Badge, Button, Grid } from "@mui/material"
import { FolderOff, FolderOpen } from "@mui/icons-material"
import { useReactiveVar } from "@apollo/client/react"
import { KickOffContext } from "@/Contexts/KickOff"
import { objectLength } from "@/utils/helperFunctions"
import { DEFAULT_SECTION } from "../../types"
import NotesSection from "../../Notes/NotesSection"
import KickOffDocumentDrawer from "./KickOffDocumentDrawer"
import { openKickOffDocumentDrawer } from "@/graphql/reactiveVars"

const KickoffActions: React.FC = () => {

  const { noteSections, setNoteSections, updateNotes, kickoffData, projectData } = useContext(KickOffContext);
  const openDocumentDrawer = useReactiveVar(openKickOffDocumentDrawer);

  const totalDocs = objectLength(kickoffData?.attachments) + objectLength(projectData?.attachments);

  const handleSectionAdd = () => {
    const updated = [...noteSections, DEFAULT_SECTION];
    setNoteSections(updated);
    updateNotes(updated);
  }

  return (
    <StepperContentContainer>
      <Grid size={openDocumentDrawer ? 6 : 12}>
        <Grid container size={12} justifyContent="space-between" mb={1}>
          <Button variant="outlined" onClick={handleSectionAdd}>Add Section</Button>
          <Badge badgeContent={totalDocs} color="primary" showZero={false}>
            <Button
              variant={openDocumentDrawer ? "contained" : "outlined"}
              startIcon={openDocumentDrawer ? <FolderOpen /> : <FolderOff />}
              onClick={() => openKickOffDocumentDrawer(!openDocumentDrawer)}
            >
              {openDocumentDrawer ? "Close Documents" : "Documents"}
            </Button>
          </Badge>
        </Grid>
        <NotesSection
          noteSections={noteSections}
          setNoteSections={setNoteSections}
          updateNotes={updateNotes}
        />
      </Grid>
      {openDocumentDrawer && <KickOffDocumentDrawer />}
    </StepperContentContainer>
  )
}

export default KickoffActions;
